var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "dialog-bottom",
      attrs: {
        title: "修改配送信息",
        visible: _vm.realVisible,
        width: "540px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.realVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formItem",
          attrs: {
            model: _vm.formItem,
            "label-width": "75px",
            rules: _vm.rules,
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "物流公司：", prop: "expressName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入物流公司" },
                model: {
                  value: _vm.formItem.expressName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "expressName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.expressName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物流单号：", prop: "trackingNumber" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入物流单号" },
                model: {
                  value: _vm.formItem.trackingNumber,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "trackingNumber",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.trackingNumber",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "联系电话：", prop: "telephone" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系电话" },
                model: {
                  value: _vm.formItem.telephone,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "telephone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.telephone",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.loadingBtn,
                size: "small",
                type: "primary",
              },
              on: {
                click: function ($event) {
                  return _vm.handleSubmit("formItem")
                },
              },
            },
            [_vm._v("提交")]
          ),
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }